import { createFileRoute } from '@tanstack/react-router'
import { ConnectedPositionsList } from '@/features/positions'
import { AuthGuard, useCurrentOrganizationId } from '@/features/auth'
import { usePositionsAccordionStore } from '@/features/positions/stores'

export const Route = createFileRoute('/(dashboard)/positions/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      role: (search.role as string) || undefined,
      level: (search.level as string) || undefined,
      positionId: (search.positionId as string) || undefined,
    }
  },
  beforeLoad: () => ({
    title: 'Positions',
  }),
})

function RouteComponent() {
  const currentOrgId = useCurrentOrganizationId()
  const search = Route.useSearch()

  // Get accordion state from Zustand store as fallback
  const { openRoles, openLevels } = usePositionsAccordionStore()

  // Prefer URL params, but fall back to store state (last opened accordion)
  const activeRole =
    search.role ||
    (openRoles.length > 0 ? openRoles[openRoles.length - 1] : undefined)
  const activeLevel =
    search.level ||
    (openLevels.length > 0
      ? openLevels[openLevels.length - 1]?.split('-')[1]
      : undefined)
  const activePositionId = search.positionId || undefined

  return (
    <AuthGuard
      requiredOrganizationRole={{
        organizationId: currentOrgId || '',
        role: 'admin',
      }}
    >
      <div className="space-y-6">
        {/* Header Section */}
        <div className="flex items-center justify-between p-6 bg-muted/30 rounded-lg">
          <div>
            <h1 className="text-2xl font-semibold text-foreground">
              Positions
            </h1>
            <p className="text-sm text-muted-foreground mt-1">
              Browse and manage available positions across different roles and
              levels.
            </p>
          </div>
        </div>

        <ConnectedPositionsList
          openRole={activeRole}
          openLevel={activeLevel}
          initialPositionId={activePositionId}
        />
      </div>
    </AuthGuard>
  )
}
